import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ResponseIcon from 'Components/Icons/ResponseIcon';
import QuizIcon from '@mui/icons-material/Quiz';
import AllQuestionsIcon from 'Components/Icons/AllQuestionsIcon';
import DraftIcon from 'Components/Icons/DraftIcon';
import StarIcon from 'Components/Icons/StarIcon';
import TrashIcon from 'Components/Icons/TrashIcon';
export const QuestionRegistrySideBars = [
    {
        label: 'All questions',
        currentPage: 1,
        templateType: 'all',
        titleToShow: 'All questions',
        path: '/dashboard/question-registry',
        key: 'total',
        icon: <AllQuestionsIcon />,
        emptyMessage: 'Your question registry is currently empty.'
    },
    {
        label: 'Drafts',
        currentPage: 1,
        templateType: 'drafted',
        titleToShow: 'Drafts',
        path: '/dashboard/question-registry',
        key: 'drafted',
        icon: <DraftIcon />,
        emptyMessage: 'No drafted questions.'
    },
    {
        label: 'Starred',
        currentPage: 1,
        templateType: 'starred',
        titleToShow: 'Starred questions',
        path: '/dashboard/question-registry',
        key: 'starred',
        icon: <StarIcon />,
        emptyMessage: 'No starred questions.'
    },
    {
        label: 'Deleted',
        currentPage: 1,
        templateType: 'deleted',
        key: 'deleted',
        titleToShow: 'Deleted Questions',
        path: '/dashboard/question-registry',
        icon: <TrashIcon />,
        emptyMessage: 'No deleted questions.'
    }
    // {
    //     label: 'Monthly question prompt',
    //     currentPage: 1,
    //     templateType: 'monthlyPrompt',
    //     path: '/dashboard/question-registry',
    //     icon: <QuizIcon />
    // }
];

export const allQuestionThreeDotsItems = [
    {
        name: 'View or edit',
        icon: '',
        hasAdminAcess: true,
        id: '334551',
        type: 'view or edit'
    },
    {
        name: 'Delete',
        icon: '',
        hasAdminAcess: true,
        id: '334552',
        type: 'delete'
    }
];

export const StarredThreeDotsItems = [
    {
        name: 'View or edit',
        icon: '',
        hasAdminAcess: true,
        id: '334553',
        type: 'view or edit'
    },
    {
        name: 'Delete',
        icon: '',
        hasAdminAcess: true,
        id: '334554',
        type: 'delete'
    }
];

export const DeletedThreeDotsItems = [
    {
        name: 'View',
        icon: '',
        hasAdminAcess: false,
        id: '334555',
        type: 'preview'
    },
    {
        name: 'Recover',
        icon: '',
        hasAdminAcess: true,
        id: '334556',
        type: ''
    }
];
export const AllQuestionOrStarredThreeDotsItems = [
    {
        name: 'Star',
        icon: '',
        hasAdminAcess: false,
        id: '334557',
        type: 'starred'
    },
    {
        name: 'Unstar',
        icon: '',
        hasAdminAcess: false,
        id: '334558',
        type: 'unstarred'
    },
    {
        name: 'Delete',
        icon: '',
        hasAdminAcess: true,
        id: '334559',
        type: 'delete'
    }
];
export const AllDeletedThreeDotsItems = [
    // {
    //     name: 'View',
    //     icon: '',
    //     hasAdminAcess: false,
    //     id: '334560',
    //     type: 'preview'
    // },
    {
        name: 'Recover',
        icon: '',
        hasAdminAcess: true,
        id: '334561',
        type: 'delete-permanently'
    }
];

export const CsvThreeDotItems = [
    {
        id: '5699989',
        name: 'Edit'
    },
    {
        id: '5699990',
        name: 'Remove'
    }
];

export const CSV_THREE_DOTS_NAME = {
    Edit: 'Edit',
    Remove: 'Remove'
};

export const ACTION_BUTTON_TYPES = {
    IMPORT: 'Import',
    ADD: 'Add'
};
